import { CAR_FINANCE_BACKEND_URL } from '../config/env'

export async function captureIP({ uniqueID, existingDataid } = {}) {
  try {
    // If an existing dataid is provided, skip the POST and just fetch the IP
    if (existingDataid) {
      let ip = null
      try {
        const ipRes = await fetch(`${CAR_FINANCE_BACKEND_URL}/api/public/ip_address`)
        const ipData = await ipRes.json()
        ip = ipData.address || null
      } catch (e) {
      }
      return { ip, dataid: existingDataid }
    }

    // Fresh capture - fetch IP and POST to datastore
    let ip = null
    try {
      const ipRes = await fetch(`${CAR_FINANCE_BACKEND_URL}/api/public/ip_address`)
      const ipData = await ipRes.json()
      ip = ipData.address || null
    } catch (e) {
    }

    const payload = {
      web_form_id: 'mot',
      websiteAquisitionIpAddress: ip,
      ...(uniqueID && { uniqueID }),
    }

    const res = await fetch(`${CAR_FINANCE_BACKEND_URL}/api/1.0/datastore`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_DATASTORE_API_KEY,
      },
      body: JSON.stringify(payload),
    })

    if (!res.ok) {
      return { ip, dataid: null }
    }

    const result = await res.json()
    const dataid = result.dataid || null

    return { ip, dataid }
  } catch (error) {
    return { ip: null, dataid: null }
  }
}
